package com.islamicmedia.site.components

import androidx.compose.runtime.*
import kotlinx.browser.document
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
fun ImagePickerButton(
    onImagePicked: (ByteArray) -> Unit,
    enabled: Boolean = true,
    isLoading: Boolean = false
) {
    val fileInputId = remember { "file-picker-${kotlin.random.Random.nextInt()}" }

    fun handleFile() {
        val input = document.getElementById(fileInputId) as? HTMLInputElement
        val file = input?.files?.item(0)
        if (file != null) {
            val reader = FileReader()
            reader.onload = {
                val arrayBuffer = reader.result as? ArrayBuffer
                if (arrayBuffer != null) {
                    val int8Array = Int8Array(arrayBuffer)
                    val bytes = ByteArray(int8Array.length) { i -> int8Array.asDynamic()[i] as Byte }
                    onImagePicked(bytes)
                }
            }
            reader.readAsArrayBuffer(file)
        }
        input?.value = ""
    }

    // Hidden file input
    Input(type = org.jetbrains.compose.web.attributes.InputType.File) {
        id(fileInputId)
        attr("accept", "image/*")
        style { display(DisplayStyle.None) }
        onChange { handleFile() }
    }

    // Button — directly opens file picker
    Div(attrs = {
        style {
            property("position", "relative")
            display(DisplayStyle.InlineBlock)
        }
    }) {
        Button(attrs = {
            onClick {
                if (enabled && !isLoading) {
                    val input = document.getElementById(fileInputId) as? HTMLInputElement
                    input?.click()
                }
            }
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                width(48.px)
                height(48.px)
                borderRadius(50.percent)
                property("background", "transparent")
                property("border", "none")
                cursor(if (enabled && !isLoading) "pointer" else "default")
                property("transition", "all 0.2s ease")
                property("flex-shrink", "0")
                opacity(if (enabled) 1.0 else 0.5)
            }
        }) {
            if (isLoading) {
                // Spinning loader
                Div(attrs = {
                    style {
                        width(22.px)
                        height(22.px)
                        property("border", "2px solid #e5e5e5")
                        property("border-top-color", "#0E7C7B")
                        borderRadius(50.percent)
                        property("animation", "spin 1s linear infinite")
                    }
                })
            } else {
                Img(src = "/images/camera.png", attrs = {
                    style {
                        width(22.px)
                        height(22.px)
                        display(DisplayStyle.Block)
                    }
                })
            }
        }

    }

    // Inject spin animation
    InjectSpinKeyframes()
}
